import { connect, mapProps, mapReadPretty, ReactFC } from '@formily/react'
import { NavBar, NavBarProps } from 'antd-mobile'
import React from 'react'
import { clickEventToProps, ueClickEvent, isNonEmptyObject } from '../../../service/utils'

export interface FormilyNavBarProps extends NavBarProps {
  clickEventProps?: any
  clickCustomEventProps?: any
}

export const FormilyNavBar = ({ clickEventProps, clickCustomEventProps, ...props}: FormilyNavBarProps) => {
  let clickProps;
  if(isNonEmptyObject(clickEventProps)) {
    clickProps = clickEventToProps(clickEventProps);
  } else {
    clickProps = {
      onClick: () => {
        ueClickEvent(clickCustomEventProps) 
      }
    }
  }
  
  const handleClick = () => {
    clickProps.onClick && clickProps.onClick();
  };

  return <NavBar {...props} onBack={handleClick} ></NavBar>
}

export const AntdNavBar: ReactFC<FormilyNavBarProps> = connect(
  NavBar,
)

export default AntdNavBar
